module.exports = __webpack_public_path__ + "static/week_week4_spot3-b96684ce3c7e2220f4699389dec4f9f2.jpg";